import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Modal,
  Button
} from '@lockerpm/design';

import itemsComponents from "../../../components/items";

import userServices from "../../../services/user";

const GetMPModal = (props) => {
  const { UserInfo, CloudImageIcon } = itemsComponents;

  const {
    visible,
    userInfo = {},
    onClose = () => {},
  } = props;

  const { t } = useTranslation();

  const [sendSuccess, setSendSuccess] = useState(false);
  const [callingAPI, setCallingAPI] = useState(false);

  useEffect(() => {
    setSendSuccess(false);
    setCallingAPI(false);
  }, [visible])

  const handleGetMPHint = async () => {
    setCallingAPI(true)
    await userServices.password_hint({ email: userInfo?.email }).then(() => {
      setSendSuccess(true);
    }).catch((error) => {
      global.pushError(error)
    });
    setCallingAPI(false)
  }

  return (
    <Modal
      width={460}
      open={visible}
      title={<></>}
      footer={false}
      style={{ top: 160 }}
      bodyStyle={{ minHeight: 280, paddingTop: 20 }}
      onCancel={onClose}
    >
      <div className="w-full text-center">
        {
          sendSuccess && <CloudImageIcon
            className="my-6"
            name="settings"
            width={96}
            height={96}
          />
        }
        <p className="text-2xl font-semibold my-2">
          {t('master_password_hint.title')}
        </p>
        <p className="text-center">
          { sendSuccess ? t('master_password_hint.get_hint_success') : t('master_password_hint.description')}
        </p>
        {
          !sendSuccess && <>
            <div className="mt-10 mb-12 flex items-center justify-center">
              <UserInfo isEmail={true}/>
            </div>
            <div className="mt-4">
              <Button
                className="w-full"
                type="primary"
                size="large"
                loading={callingAPI}
                onClick={() => handleGetMPHint()}
              >
                {t('master_password_hint.button') }
              </Button>
            </div>
          </>
        }
      </div>
    </Modal>
  );
}

export default GetMPModal;